<ul class="nav nav-pills p-3 mb-3 rounded align-items-center card flex-row">
    <li class="nav-item">
        <a href="javascript:void(0)" class="nav-link gap-6 note-link d-flex align-items-center justify-content-center px-3 px-md-3 <%= currentFilter === 'all' ? 'active' : '' %>" data-filter="all">
            <i class="ti ti-list fill-white"></i>
            <span class="d-none d-md-block fw-medium">All</span>
        </a>
    </li>
    <li class="nav-item">
        <a href="javascript:void(0)" class="nav-link gap-6 note-link d-flex align-items-center justify-content-center px-3 px-md-3 <%= currentFilter === 'active' ? 'active' : '' %>" data-filter="active">
            <i class="ti ti-briefcase fill-white"></i>
            <span class="d-none d-md-block fw-medium">Active</span>
        </a>
    </li>
    <li class="nav-item">
        <a href="javascript:void(0)" class="nav-link gap-6 note-link d-flex align-items-center justify-content-center px-3 px-md-3 <%= currentFilter === 'inactive' ? 'active' : '' %>" data-filter="inactive">
            <i class="ti ti-share fill-white"></i>
            <span class="d-none d-md-block fw-medium">Inactive</span>
        </a>
    </li>
    <li class="nav-item ms-auto">
        <a href="javascript:void(0)"
           class="btn btn-primary d-flex align-items-center px-3 gap-6" data-type="create-pack-btn">
            <i class="ti ti-package fs-4"></i>
            <span class="d-none d-md-block fw-medium fs-3">Create Pack</span>
        </a>
    </li>
</ul>

<div class="tab-content">
    <% if ( packs && packs.length > 0 ) { %>
        <div data-type="pack-list-container" class="row">
            <% packs.forEach( ( pack ) => { %>
                <div class="col-md-4 mb-4">
                    <pack-card></pack-card>
                </div>
            <% }); %>

        </div>

    <% }  else {  %>

        <div class="d-flex flex-column align-items-center justify-content-center text-center py-5">
            <div class="empty-state-icon mb-4">
                <i class="ti ti-package display-4 text-muted"></i>
            </div>
            <% if ( totalCount === 0 ) { %>
                <h4 class="mb-2 text-muted">No Packs Found</h4>
                <p class="text-muted mb-4">You haven't created any packs yet. Get started by creating your first pack.</p>
                <a href="javascript:void(0)" class="btn btn-primary" data-type="create-pack-btn">
                    <i class="ti ti-package me-2"></i>
                    Create Your First Pack
                </a>
            <% } else { %>
                <h4 class="mb-2 text-muted">No <%= currentFilter %> packs</h4>
                <p class="text-muted mb-4">There are no packs matching the selected filter.</p>
            <% } %>
        </div>

    <% }    %>

</div>

<!-- Premium Required Modal -->
<div class="modal fade" id="premiumRequiredModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Premium Feature</h5>
                <button type="button" class="btn-close" data-type="premium-modal-close" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="text-center py-3">
                    <div class="rounded-circle bg-warning-subtle d-flex align-items-center justify-content-center mx-auto mb-3" style="width: 64px; height: 64px;">
                        <iconify-icon icon="solar:lock-line-duotone" class="fs-9 text-warning"></iconify-icon>
                    </div>
                    <h5 class="mb-2">Packs require a Business or Enterprise plan</h5>
                    <p class="text-muted mb-0">Upgrade your subscription to create packs and bundle multiple document templates into a single request.</p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-type="premium-modal-cancel">Cancel</button>
                <button type="button" class="btn btn-primary" data-type="premium-modal-upgrade">
                    <iconify-icon icon="solar:crown-line-duotone" class="me-1"></iconify-icon>
                    Upgrade Subscription
                </button>
            </div>
        </div>
    </div>
</div>
